export const LocalStorageTypes = {
  //For FileHub
  CLIENTS: 'clients',
  DELIMETERS: 'delimeters',
  FILETYPES: 'fileTypes',
  LOCATIONS: 'locations',
  PRODUCTS: 'products',
  SCHEMAS: 'schemas',
  SUBPRODUCTS: 'subproducts',
  SKIPOPTIONS: 'skipOptions',
  VERSIONS: 'versions',

  GENERICS: 'generics',

  CATEGORIES: 'categories',
  MASTERCATEGORIES: 'masterCategories',
  MODELNUMBER: 'modelNumber',
  RETAILERS: 'retailers',
  SOURCES: 'sources',
  USERS: 'users',
};
